import { BrowserAgent } from "@newrelic/browser-agent";
import config from "./config";

let newRelicInstance: BrowserAgent;

export const getNewRelic = (): BrowserAgent | null => {
  const newRelic = process.env.REACT_APP_NEW_RELIC === "true" || false;

  if (newRelic) {
    return newRelicInstance || (newRelicInstance = new BrowserAgent(config));
  }

  return null;
};

export const NewRelic = {
  get instance(): BrowserAgent | undefined {
    return getNewRelic();
  },
};
